export const constant = {
  devEnv: "Dev",
  stagingEnv: "Staging",
};

export const DATEFORMAT = "YYYY-MM-DD";
export const DATETIMEFORMAT = "YYYY-MM-DD HH:mm";
export const ADITRO_USERNAME_PREFIX = "aditrologin_";
